import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import TreeMenu, { TreeMenuPropTypes } from '../TreeMenu';
import { GaugeTreeOption } from '../GaugeTreeOption';

const GaugeTreeMenu = ({
  menu,
  disabled,
  selectedOptions,
  showOnlySelected,
  showOnlyNonEmpty,
  gaugeSelectorOptions,
  isOption,
  isSkipped,
  isExpanded,
  getOptionId,
  getOptionLabel,
  getMenuId,
  getMenuLabel,
  onChange,
  onExpandGroup,
  getOptionDescription,
  getOptionValueForGauge,
  setOptionValueFromGauge,
  isUpdatingEntity,
}) => {
  const renderOption = useCallback(
    (option, treeProps, treeState) => {
      const { disabled, onChange, getOptionId, getOptionLabel, selectedOptions } = treeProps;

      const { parentExpanded } = treeState;

      const key = `gauge-tree-option-${getOptionId(option)}`;

      return (
        <GaugeTreeOption
          key={key}
          option={option}
          visible={parentExpanded && option.visible}
          disabled={disabled}
          selectedOptions={selectedOptions}
          onChange={onChange}
          getOptionId={getOptionId}
          getOptionLabel={getOptionLabel}
          getOptionDescription={getOptionDescription}
          gaugeSelectorOptions={gaugeSelectorOptions}
          getOptionValueForGauge={getOptionValueForGauge}
          setOptionValueFromGauge={setOptionValueFromGauge}
          isUpdatingEntity={isUpdatingEntity}
        />
      );
    },
    [gaugeSelectorOptions, getOptionValueForGauge, setOptionValueFromGauge, getOptionDescription, isUpdatingEntity],
  );

  return (
    <TreeMenu
      menu={menu}
      disabled={disabled}
      selectedOptions={selectedOptions}
      showOnlySelected={showOnlySelected}
      showOnlyNonEmpty={showOnlyNonEmpty}
      isOption={isOption}
      isSkipped={isSkipped}
      isExpanded={isExpanded}
      getOptionId={getOptionId}
      getOptionLabel={getOptionLabel}
      getOptionDescription={getOptionDescription}
      getMenuId={getMenuId}
      getMenuLabel={getMenuLabel}
      renderOption={renderOption}
      onChange={onChange}
      onExpandGroup={onExpandGroup}
    />
  );
};

GaugeTreeMenu.propTypes = {
  ...TreeMenuPropTypes,
  gaugeSelectorOptions: PropTypes.arrayOf(PropTypes.object),
  getOptionValueForGauge: PropTypes.func.isRequired,
  setOptionValueFromGauge: PropTypes.func.isRequired,
};

// eslint-disable-next-line import/no-default-export
export default memo(GaugeTreeMenu);
